import { render } from "./Dialogs.vue?vue&type=template&id=9d4aa1c0&ts=true"
import script from "./Dialogs.vue?vue&type=script&lang=ts"
export * from "./Dialogs.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__